const APP_ID = 'd4412f10-f26a-462b-b4e6-3439873cf448'
const SAFARI_WEB_ID = 'web.onesignal.auto.4463433a-b41c-4a34-809b-879a9d93883b'
export default async function({ app: { store, $api } }) {
  if (process.client) {
    window.OneSignalDeferred = window.OneSignalDeferred || []

    store.watch(
      () => store.getters['user/isLoggedIn'],
      () => {
        if (!store.getters['user/isLoggedIn']) return
        if ('Notification' in window) {
          window.Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
              window.OneSignalDeferred = window.OneSignalDeferred || []
              OneSignalDeferred.push(async function(OneSignal) {
                await OneSignal.init({
                  appId: APP_ID,
                  safari_web_id: SAFARI_WEB_ID,
                })
                await OneSignal.login(store.getters['user/userId'].toString())
                const oneSignalId = OneSignal.User['_currentUser'].onesignalId
                await $api.notifications.postUser({ id: oneSignalId } )
              })

            }
            else {
              // Разрешение не получено
            }
          })
        }

      }
    )

  }
}
